import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, signal } from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { ICustomerListModel } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { EditorModule } from "primeng/editor";
import { CustomerService } from "../../../../shared/services/customers/customers.service.mjs";

@Component({
  selector: "app-mass-email",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    BlockUIModule,
    CardModule,
    EditorModule,
  ],
  templateUrl: "./mass-email.component.html",
  styleUrls: ["./mass-email.component.css"],
})
export class MassEmailComponent implements OnInit {
  formGroup: FormGroup | undefined;

  constructor(protected customerService: CustomerService) {}

  ngOnInit() {
    this.formGroup = new FormGroup({
      text: new FormControl(),
      subject: new FormControl(),
    });
  }

  @Input()
  selectedCustomers = signal<ICustomerListModel[] | undefined>(undefined);

  @Input()
  dialogVisible = signal(false);

  @Output() visibilityChanged = new EventEmitter<boolean>();


  async sendEmail() {
    const html = this.formGroup?.get("text")?.value;
    const subject = this.formGroup?.get("subject")?.value;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const text = doc.documentElement.textContent || "";

    const emailArray: string[] | undefined = this.selectedCustomers()?.map(
      (obj) => obj.email
    );

    if (Array.isArray(emailArray)) {
      const result = await this.customerService.sendEmail(
        emailArray,
        "billing@claddedglassbroadband.com",
        "Billing @ Cladded Glass Broadband",
        subject,
        text,
        html
      );

      console.log("[EMAIL]", result);

      if (result.status === FUNCTION_RESULT_STATUS.SUCCESS)
      {
        this.visibilityChanged.emit(false);
      }
    }
  }
}
